import React, { useMemo } from 'react';
import { Text } from 'src/@vymo/ui/atoms';
import { Accordion, NoData, Skelton } from 'src/@vymo/ui/blocks';
import { getBeforeSaveHookConfig } from 'src/@vymo/ui/components/history/queries';
import { Form } from 'src/@vymo/ui/molecules';
import { FormVersion } from 'src/@vymo/ui/molecules/form/types';
import { ReactComponent as CaretRight } from 'src/assets/icons/caretRight.svg';
import { Keys, locale } from 'src/i18n';
import { getRevyreConfig } from 'src/models/lmsConfig/selectors';
import { SUPERVISOR_REVIEW_DOMAINTYPE } from 'src/modules/constants';
import { useAppSelector } from 'src/store/hooks';
import { TAB_STATUS_KEYS } from '../../constant';
import { getStatus, getSupervisorReviews } from '../../selector';
import { getTransformedSupervisorReviews } from './queries';
import SupervisorReviewHeader from './titleHeader';
import detailsStyles from '../../index.module.scss';
import styles from './index.module.scss';

function SupervisorReview(props) {
  const reviews = useAppSelector(getSupervisorReviews);
  const revyreConfig = useAppSelector(getRevyreConfig);
  const transformedReviews = useMemo(
    () => getTransformedSupervisorReviews(reviews, revyreConfig),
    [reviews, revyreConfig],
  );
  const status = useAppSelector((state) =>
    getStatus(state, TAB_STATUS_KEYS.SUPERVISOR_REVIEW),
  );

  return (
    <div
      className={detailsStyles.detailsWrapper__detailsBody__relatedRecords}
      data-test-id="supervisor-review-history"
    >
      <Text type="h6">{locale(Keys.SUPERVISOR_REVIEW)}</Text>
      {status === 'loading' && <Skelton rounded lines={8} />}
      {status === 'error' && (
        <NoData message={locale(Keys.UNABLE_TO_LOAD_SUPERVISOR_REVIEWS)} />
      )}
      {status === 'done' && !transformedReviews.length && (
        <NoData
          message={locale(
            Keys.NO_SUPERVISOR_REVIEWS_RECORDED_YET_FOR_THIS_CASE,
          )}
        />
      )}
      {status === 'done' && Boolean(transformedReviews.length) && (
        <div className={styles.supervisorReview__records}>
          {transformedReviews.map((review, index) => (
            <Accordion
              key={review.id}
              data-test-id={`supervisor-review-${review.id}`}
              title={<SupervisorReviewHeader review={review} />}
              type="default"
              open={index === 0}
              iconPosition="left"
              iconLeft={<CaretRight />}
              className={styles.supervisorReview__records__accordion}
            >
              {Boolean(review.inputs.length) && (
                <Form
                  ref={null}
                  id={`supervisorReview-${review.id}`}
                  name={`supervisorReview-${review.id}`}
                  span="1fr 1fr"
                  // eslint-disable-next-line @typescript-eslint/no-unused-vars
                  onChange={() => {}}
                  className={styles.supervisorReview__records__form}
                  config={{
                    version: FormVersion.webRevyre,
                    data: review.inputs,
                    grouping: review.grouping,
                    fieldItemConfig: {
                      showDisabledIcon: true,
                    },
                    ...getBeforeSaveHookConfig({
                      revyre: props?.revyre,
                      workflowType: SUPERVISOR_REVIEW_DOMAINTYPE,
                      entityId: review.id,
                    }),
                    viewMode: true,
                    metaData: {
                      profileDetails: props?.profileDetails,
                    },
                  }}
                  value={review.formValues}
                />
              )}
            </Accordion>
          ))}
        </div>
      )}
    </div>
  );
}

export default SupervisorReview;
